import { render, staticRenderFns } from "./WindowStructureDamaged.vue?vue&type=template&id=ba4e855a"
import script from "./WindowStructureDamaged.vue?vue&type=script&lang=ts"
export * from "./WindowStructureDamaged.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports